module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAgCAYAAAC7FpAiAAABRElEQVRYR2NkgALOgI58JgaGAAYGRgeYGDZaVfA1w/mEHqxK7r4XZtBfUIZPO5Xk/h/4x8Cw4fuGiokgAxlBBFdA53pGsAcIg8HhCYg7/zMwbPi2oTyQkTugPYGBgWk+YedDVAwmT0Bc9C+RkTug8wADA4P90PUEw8Hh4IkPw8ETDKOeQM9H9CtiUW0ejYnRmCC2TCdC3fBITh1dznf+/mdUJsLDYCXCHN8Y0g2OYVX+/gcXw/QLVsQaRRV1n35yMjA+38rzQ4LnCztVTBwAQ55+5h/1xACEO6aVozExKKKBgYFh+MTEsChih0GnaLQpjpG3R5viFBR3w6MBOJqx0ZLAaJ4gO0/8/zgc8gRo8GwYDGOCYpEroGMDIwOjPzExOsjGYg9+3VDuAB4VBwHOgM4CyNA+/nHZQeKJg5Ch/fIJILcDAPWNEXroQ5rbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/c169.png
// module id = KPw8
// module chunks = 18